export default "__VITE_ASSET__BvpkvBoz__"